import React, { useState} from 'react';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';

import AccessRightSideMenu from '../accessRights/AccessRightsSideMenu';



const AccessRightsTab = (props) => {

    
  
    const [selectedOption, setSelectedOption ] = useState('');
    const [blockName, setBlockName ] = useState('');
    const [adminMenu, setAdminMenu] = useState(false);
    const {t} = useTranslation();
  

    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const onValueChange = (event) => {
       // event.preventDefault();
        setSelectedOption( parseInt(event.target.value));
        RestService.callAnyApi('user/saveAccessRights?userId='+props.entityId+"&entityName="+blockName+"&value="+event.target.value, null)
        .then((data) => {                                                 
                    if(data.responseMessage==='OK'){
                        toast.success(t('general.message.saveSucceed'));                                                                     
                    }else{
                        showError(null,data.responseMessage);
                    }
                
               
        })
        .catch((error) => {               
          showError(error,null);
        });
    }


    const handleCallback = (blockName) => {   
      setBlockName(blockName);
      getRights(blockName);
    }
    

    const getRights = (blockName) => {

      blockName.includes('Admin') ? setAdminMenu(true) : setAdminMenu(false)

      console.log("get rights for:"+blockName);
      RestService.callAnyApi('user/getAccessRights?id='+props.entityId, null)
      .then((data) => {
            console.log(data);
            //setSelectedOption
           
          // disabledAccountRef.current.select.setValue(data.disabledAccount);
          switch(blockName){
            case "users":
              setSelectedOption(data.rightsEntityUser);
            break; 
            case "departments":
              setSelectedOption(data.rightsEntityDepartment);
            break;
            case "overview":
              setSelectedOption(data.rightsEntityOverview);
            break;
            case "attendanceSelf":
              setSelectedOption(data.rightsEntityAttendanceSelf);
            break;
            case "attendanceOthers":
              setSelectedOption(data.rightsEntityAttendanceOthers);
            break;
            case "attendanceAdmin":
              setSelectedOption(data.rightsEntityAttendanceAdmin);
            break;
            case "tasks":
              setSelectedOption(data.rightsEntityTasks);
            break;      
            default:      
          }
                      
      })
      .catch((error) => {    
        toast.error(error);
      });

    }

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
       
            <div className="row justify-content-center align-self-center">
                <div className="col-5 col-sm-5  col-lg-5 bg-light overflow-auto" style={{"maxHeight": "400px"}}>
                    <AccessRightSideMenu
                      parentCallback={handleCallback}
                    />
                </div>
                <div className="col-7 col-sm-7 col-lg-7 justify-content-center align-self-center"  style={{"display": "flex", "justifyContent": "center"}}>
                      
                            <div className="form-group" style={blockName!=='' && !adminMenu ? {} : { display: 'none' }} >
                              
                                    <div className="radio">
                                          <label>
                                              <input 
                                                type="radio"
                                                value="2" 
                                                checked={selectedOption === 2}
                                                onChange={onValueChange}
                                              />
                                              <span><i className="fa fa-check-circle mx-sm-2" style={{"color": "green"}}></i>{t('general.label.full')}</span>
                                          </label>
                                    </div>       
                                    <div className="radio">
                                          <label>
                                              <input 
                                                type="radio"
                                                value="1"
                                                checked={selectedOption === 1}
                                                onChange={onValueChange}
                                               />
                                              <span><i className="fa fa-eye mx-sm-2" style={{"color": "#007BFF"}}></i>{t('general.label.view')}</span>
                                          </label>
                                    </div>        	    	 				  
                                    <div className="radio">
                                          <label>
                                              <input
                                                 type="radio"
                                                 value="0"
                                                 checked={selectedOption === 0}
                                                 onChange={onValueChange}
                                              />
                                              <span><i className="fa fa-times-circle mx-sm-2" style={{"color": "red"}}></i>{t('general.label.deny')}</span>
                                          </label>
                                    </div>        	          					
                            </div>


                            <div className="form-group" style={blockName!=='' && adminMenu ? {} : { display: 'none' }} >
                              
                              <div className="radio">
                                    <label>
                                        <input 
                                          type="radio"
                                          value="1" 
                                          checked={selectedOption === 1}
                                          onChange={onValueChange}
                                        />
                                        <span><i className="fa fa-check-circle mx-sm-2" style={{"color": "green"}}></i>{t('general.label.yes')}</span>
                                    </label>
                              </div>       
                              <div className="radio">
                                    <label>
                                        <input 
                                          type="radio"
                                          value="0"
                                          checked={selectedOption === 0}
                                          onChange={onValueChange}
                                         />
                                       <span><i className="fa fa-times-circle mx-sm-2" style={{"color": "red"}}></i>{t('general.label.no')}</span>
                                    </label>
                              </div>        	    	 				                                
                      </div>



                  </div>    
                
            </div>
              
             

        </div>
    );
};

export default AccessRightsTab;